/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { IcpmcpError } from "./icpmcperror.js";

/** The fallback error class if no more specific error class is matched */
export class IcpmcpDefaultError extends IcpmcpError {
  constructor(
    message: string,
    httpMeta: {
      response: Response;
      request: Request;
      body: string;
    },
  ) {
    if (message) {
      message += `: `;
    }
    message += `Status ${httpMeta.response.status}`;
    const contentType = httpMeta.response.headers.get("content-type") || `""`;
    if (contentType !== "application/json") {
      message += ` Content-Type ${
        contentType.includes(" ") ? `"${contentType}"` : contentType
      }`;
    }
    const body = httpMeta.body || `""`;
    message += body.length > 100 ? "\n" : " ";
    message += `Body ${body}`;
    message = message.trim();
    super(message, httpMeta);
    this.name = "IcpmcpDefaultError";
  }
}
